import type { SVGProps } from 'react';

const CodeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 3.25C0 1.45507 1.45507 0 3.25 0H5.25C5.66421 0 6 0.335786 6 0.75C6 1.16421 5.66421 1.5 5.25 1.5H3.25C2.2835 1.5 1.5 2.2835 1.5 3.25V5.25C1.5 5.66421 1.16421 6 0.75 6C0.335786 6 0 5.66421 0 5.25V3.25ZM12 0.75C12 0.335786 12.3358 0 12.75 0H14.75C16.5449 0 18 1.45507 18 3.25V5.25C18 5.66421 17.6642 6 17.25 6C16.8358 6 16.5 5.66421 16.5 5.25V3.25C16.5 2.2835 15.7165 1.5 14.75 1.5H12.75C12.3358 1.5 12 1.16421 12 0.75ZM0.75 12C1.16421 12 1.5 12.3358 1.5 12.75V14.75C1.5 15.7165 2.2835 16.5 3.25 16.5H5.25C5.66421 16.5 6 16.8358 6 17.25C6 17.6642 5.66421 18 5.25 18H3.25C1.45507 18 0 16.5449 0 14.75V12.75C0 12.3358 0.335786 12 0.75 12ZM17.25 12C17.6642 12 18 12.3358 18 12.75V14.75C18 16.5449 16.5449 18 14.75 18H12.75C12.3358 18 12 17.6642 12 17.25C12 16.8358 12.3358 16.5 12.75 16.5H14.75C15.7165 16.5 16.5 15.7165 16.5 14.75V12.75C16.5 12.3358 16.8358 12 17.25 12ZM7 4H4V7H7V11H4V14H7V11H11V14H14V11H11V7H14V4H11V7H7V4Z"
      fill="currentColor"
    />
  </svg>
);

export default CodeIcon;
